module.exports = __webpack_public_path__ + "static/media/recognize.f6ba18c2.png";